import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Film, Tv, Mic, Heart } from 'lucide-react';
import TopNav from './TopNav';
import Sidebar from './Sidebar';
import MiniPlayer from './MiniPlayer';
import DetailModal from './DetailModal';
import { useApp } from '../context/AppContext';

const MOBILE = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/movies', label: 'Movies', icon: Film },
  { to: '/shows', label: 'Shows', icon: Tv },
  { to: '/podcasts', label: 'Podcasts', icon: Mic },
  { to: '/my-list', label: 'My List', icon: Heart },
];

export function MobileNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-[60] flex bg-[#0B0A0E]/90 backdrop-blur-md border-t border-[#26212F] shadow-[0_-4px_16px_rgba(40,20,80,0.06)]" data-testid="mobile-nav">
      {MOBILE.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `mnav-item ${isActive ? 'active' : ''}`}>
          <Icon size={20} strokeWidth={1.8} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default function Layout({ children, bottom = null }) {
  const { audio } = useApp();
  const hasMini = !!audio.episode;
  return (
    <div className="clax-shell">
      <TopNav />
      <div className="relative z-[1] pt-[70px] pb-[60px] lg:pb-0" style={hasMini ? { paddingBottom: 72 } : undefined}>
        <div className="flex">
          <Sidebar />
          <main className="flex-1 min-w-0">{children}</main>
        </div>
        {bottom}
      </div>
      <MobileNav />
      <MiniPlayer />
      <DetailModal />
    </div>
  );
}
